/* Oral Care Quiz — vanilla JS, no deps. window.SmileQuiz.mount(root, data, opts) */
(function () {
  "use strict";

  var ICONS = {
    arrow: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    check: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>',
    shield: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2l8 3v6c0 5-3.5 9-8 11-4.5-2-8-6-8-11V5l8-3z"/><path d="M9 12l2 2 4-4"/></svg>',
    star: '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 6.6 7.1.6-5.4 4.7 1.6 7-6.2-3.9-6.2 3.9 1.6-7-5.4-4.7 7.1-.6z"/></svg>',
    back: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>',
    x: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };

  var QUESTIONS = [
    { id: "concern", prompt: "What bothers you most about your teeth right now?", options: [
      { id: "stains", label: "Yellowing or stains", sub: "They look dull in photos", emoji: "🟡" },
      { id: "breath", label: "Bad breath through the day", sub: "Even after brushing", emoji: "💨" },
      { id: "plaque", label: "They never feel properly clean", sub: "Plaque, rough feeling", emoji: "🪥" },
      { id: "sensitive", label: "Sensitivity or bleeding gums", sub: "Cold, sweet or brushing hurts", emoji: "❄️" },
      { id: "general", label: "Nothing specific, just want better", emoji: "😐" }
    ] },
    { id: "when", prompt: "When is it worst?", options: [
      { id: "morning", label: "First thing in the morning", emoji: "🌅" },
      { id: "meals", label: "After meals, chai or coffee", emoji: "☕" },
      { id: "allday", label: "Pretty much all day", emoji: "🕐" },
      { id: "cold", label: "When I eat something cold or sweet", emoji: "🍨" }
    ] },
    { id: "current", prompt: "What are you using today?", options: [
      { id: "chemist", label: "A regular toothpaste from the chemist", emoji: "🏪" },
      { id: "electric", label: "An electric brush", emoji: "⚡" },
      { id: "whitening", label: "I've already tried whitening products", emoji: "✨" },
      { id: "natural", label: "Herbal or natural products", emoji: "🌿" }
    ] },
    { id: "time", prompt: "How much time does your mouth get each day?", options: [
      { id: "rushed", label: "Under 2 minutes, I'm rushed", emoji: "⏱️" },
      { id: "twice", label: "2 minutes, twice a day", emoji: "✅" },
      { id: "full", label: "A full routine: brush, rinse, scrape", emoji: "🧴" }
    ] },
    { id: "goal", prompt: "In 30 days, what would make you happiest?", options: [
      { id: "whiter", label: "Visibly whiter teeth", emoji: "😁" },
      { id: "fresher", label: "Breath I don't think about", emoji: "🌬️" },
      { id: "cleaner", label: "That just-left-the-dentist clean", emoji: "🦷" },
      { id: "routine", label: "A routine I actually stick to", emoji: "📅" },
      { id: "nopain", label: "No more sensitivity", emoji: "🙌" }
    ] }
  ];

  var CONCERN_LABEL = {
    stains: "stain‑prone teeth", breath: "all-day fresh breath", plaque: "a deeper clean",
    sensitive: "sensitive teeth and gums", general: "an all-round upgrade"
  };

  function pickKit(a, kits) {
    switch (a.concern) {
      case "stains": return kits["purple-whitening"];
      case "breath": return kits["bad-breath"];
      case "plaque": return kits.charcoal;
      case "sensitive": return kits.essentials;
    }
    switch (a.goal) {
      case "whiter": return kits["purple-whitening"];
      case "fresher": return kits["bad-breath"];
      case "cleaner": return kits.charcoal;
      case "routine": return kits["morning-night"];
      case "nopain": return kits.essentials;
    }
    if (a.when === "morning" || a.time === "full") return kits["morning-night"];
    return kits.complete;
  }

  function reasonsFor(a, kit) {
    var r1 = {
      stains: kit.hero + " neutralises yellow tones on contact, so teeth look brighter from the first brush rather than after weeks of bleaching.",
      breath: kit.hero + " goes after the sulphur-producing bacteria on your tongue and gumline instead of covering them with mint.",
      plaque: kit.hero + " lifts the film that regular paste leaves behind, and the tongue cleaner clears what brushing misses.",
      sensitive: kit.hero + " are SLS-free and gentle on enamel and gums, with no harsh foaming agents that make sensitivity worse.",
      general: kit.hero + ": the basics done properly, and the rest of the box fills the gaps most routines have."
    };
    var r2 = {
      chemist: "You're on a regular chemist paste. Every paste in this kit is free of SLS and artificial colours, which is usually the first thing people notice.",
      electric: "You already brush electric, so the paste and rinse are the missing pieces. The manual brushes in the box work as travel spares.",
      whitening: "You've tried whitening before. This kit whitens without peroxide, so there's no sensitivity trade-off this time.",
      natural: "You prefer natural products. These formulas skip SLS, parabens and artificial sweeteners, without giving up on results."
    };
    var r3 = {
      rushed: "You're short on time. The mouthwash and tongue cleaner take 30 seconds together and do the work a rushed brush can't.",
      twice: "Two minutes twice a day is the right base. This kit adds the rinse and scrape that turn a good brush into a full clean.",
      full: "You already do the full routine. This box replaces every step with the better version, at less than buying them one by one."
    };
    var r3t = {
      morning: "Mornings are the worst for you. The tongue cleaner clears the overnight build-up that causes it.",
      meals: "Chai, coffee and meals are the trigger. The mouth spray and rinse are built for the middle of the day, when you can't brush.",
      allday: "It's an all-day thing for you, which points to bacteria rather than food. The rinse and paste here keep working between brushes.",
      cold: "Cold and sweet things set it off. Nothing in this kit has the harsh foaming agents that make that worse."
    };
    return [
      r1[a.concern || "general"],
      r2[a.current || "chemist"],
      (a.time && r3[a.time]) ? r3[a.time] : r3t[a.when || "allday"]
    ];
  }

  function cartUrl(kit, a) {
    var q = "storefront=true&attributes%5Bquiz%5D=oral-care-quiz";
    Object.keys(a).forEach(function (k) {
      if (a[k]) q += "&attributes%5Bquiz_" + k + "%5D=" + encodeURIComponent(a[k]);
    });
    return "/cart/" + kit.variantId + ":1?" + q;
  }

  function inr(n) { return "₹" + Number(n).toLocaleString("en-IN"); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function trustList(trust, compact) {
    var items = [
      [ICONS.check, trust.dentist], [ICONS.shield, trust.users], [ICONS.check, trust.clinical], [ICONS.check, trust.orders]
    ];
    return '<ul class="sq-trust' + (compact ? " sq-trust--compact" : "") + '">' + items.map(function (it) {
      return '<li><span class="sq-trust__ic">' + it[0] + "</span><span>" + esc(it[1]) + "</span></li>";
    }).join("") + "</ul>";
  }


  /* ------------------------------------------------------------------
     Path tracking. Every route through this page writes a breadcrumb to
     the cart's `quiz_path` attribute, which Shopify carries onto the
     order. "collection" means they skipped the quiz, "quiz>collection"
     means they browsed after answering, and so on. Cart attributes
     survive page loads, so the trail is built up across visits to the
     collection and back.
  ------------------------------------------------------------------ */
  function cartAttrs() {
    if (!window.fetch) return Promise.resolve({});
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return (c && c.attributes) || {}; })
      .catch(function () { return {}; });
  }

  function stampPath(step, extra) {
    if (!window.fetch) return Promise.resolve();
    return cartAttrs().then(function (prev) {
      var trail = (prev.quiz_path || "").split(">").filter(Boolean);
      if (trail[trail.length - 1] !== step) trail.push(step);
      if (trail.length > 6) trail = trail.slice(-6);
      var attrs = {};
      Object.keys(extra || {}).forEach(function (k) { attrs[k] = extra[k]; });
      attrs.quiz = "oral-care-quiz";
      attrs.quiz_path = trail.join(">");
      return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: attrs })
      });
    }).catch(function () {});
  }

  function browseUrl(base) {
    return base + (base.indexOf("?") > -1 ? "&" : "?") +
      "utm_source=oral-care-quiz&utm_medium=onsite&utm_campaign=quiz-skip";
  }

  function mount(root, data, opts) {
    opts = opts || {};
    var kits = data.kits, trust = data.trust;
    var state = { stage: opts.intro ? "intro" : "quiz", step: 0, answers: {} };
    var timer = null;

    function render() {
      if (state.stage === "intro") renderIntro();
      else if (state.stage === "quiz") renderQuiz();
      else if (state.stage === "matching") renderMatching();
      else renderResult();
    }

    function renderIntro() {
      var html = '<section class="sq-screen sq-intro"><div>';
      html += '<span class="sq-eyebrow">The 60-second oral care quiz</span>';
      html += '<h1 class="sq-serif">Which ₹899 kit is right for <em>your</em> teeth?</h1>';
      html += '<p class="sq-lead">5 taps, no typing. We match you to one of 6 kits, each a flat <b>₹899</b> and worth up to ₹1,325 bought separately.</p>';
      html += trustList(trust, true) + "</div>";
      html += '<div class="sq-cta"><button type="button" class="sq-btn" data-sq="start">Take the Quiz ' + ICONS.arrow + "</button>";
      html += '<a class="sq-btn sq-btn--ghost" data-sq="browse" href="' + esc(browseUrl(data.collectionUrl)) + '">Skip and view all kits</a>';
      html += '<p class="sq-fine">Takes about a minute. No email needed.</p></div></section>';
      root.innerHTML = html;
    }

    function renderQuiz() {
      var q = QUESTIONS[state.step], total = QUESTIONS.length, sel = state.answers[q.id];
      var showBack = state.step > 0 || !!opts.onClose || !!opts.intro;
      var html = '<section class="sq-screen"><div class="sq-bar">';
      html += showBack
        ? '<button type="button" class="sq-back" data-sq="back" aria-label="' + (state.step === 0 ? "Close" : "Back") + '">' + (state.step === 0 ? ICONS.x : ICONS.back) + "</button>"
        : '<span class="sq-eyebrow">Oral care quiz</span>';
      html += '<div class="sq-progress" role="progressbar" aria-valuemin="0" aria-valuemax="' + total + '" aria-valuenow="' + (state.step + 1) + '"><i style="width:' + ((state.step + 1) / total * 100) + '%"></i></div>';
      html += '<span class="sq-count">' + (state.step + 1) + "/" + total + "</span></div>";
      html += '<h2 class="sq-q sq-serif">' + esc(q.prompt) + "</h2>";
      html += '<div class="sq-opts" role="group" aria-label="' + esc(q.prompt) + '">';
      q.options.forEach(function (o) {
        html += '<button type="button" class="sq-opt' + (sel === o.id ? " is-sel" : "") + '" data-sq="opt" data-id="' + o.id + '" aria-pressed="' + (sel === o.id) + '">';
        html += '<span class="sq-opt__ic" aria-hidden="true">' + o.emoji + "</span><span><span class=\"sq-opt__t\">" + esc(o.label) + "</span>" + (o.sub ? '<span class="sq-opt__s">' + esc(o.sub) + "</span>" : "") + "</span></button>";
      });
      html += "</div>";
      html += '<p class="sq-foot">' + ICONS.shield + "<span>" + esc(trust.users) + " · every match is a ₹899 kit</span></p></section>";
      root.innerHTML = html;
    }

    function renderMatching() {
      var html = '<section class="sq-screen sq-match" aria-live="polite"><div class="sq-pulse"></div>';
      html += '<h2 class="sq-serif">Matching you with the best combo…</h2>';
      html += '<p class="sq-sub">Sorting 6 kits for ' + esc(CONCERN_LABEL[state.answers.concern || "general"]) + ".</p>";
      html += '<div class="sq-trustwrap"><span class="sq-eyebrow">Why people trust Perfora</span>' + trustList(trust, false);
      html += '<p class="sq-fine">' + esc(trust.sharkTank) + " · Featured in " + esc(trust.press.slice(0, 3).join(", ")) + "</p></div></section>";
      root.innerHTML = html;
      clearTimeout(timer);
      timer = setTimeout(function () { state.stage = "result"; render(); scrollTop(); }, 2600);
    }

    function renderResult() {
      var a = state.answers, kit = pickKit(a, kits), reasons = reasonsFor(a, kit);
      var savings = kit.mrp - kit.price, buy = cartUrl(kit, a);
      var html = '<section class="sq-result"><div class="sq-head"><span class="sq-eyebrow">Your match</span>';
      html += '<h1 class="sq-serif">Your ₹899 kit for <em>' + esc(CONCERN_LABEL[a.concern || "general"]) + "</em></h1></div>";
      html += '<figure class="sq-fig"><img src="' + esc(kit.image) + '" alt="' + esc(kit.title) + '" loading="eager"></figure>';
      html += '<div class="sq-kit"><div><h2>' + esc(kit.title) + '</h2><p class="sq-tag">' + esc(kit.tagline) + "</p></div>";
      html += '<div class="sq-price"><b>' + inr(kit.price) + "</b><s>" + inr(kit.mrp) + "</s></div></div>";
      if (savings > 0) html += '<span class="sq-save">You save ' + inr(savings) + " vs. buying separately</span>";
      html += '<ul class="sq-claims">' + kit.claims.map(function (c) { return "<li>" + ICONS.check + esc(c) + "</li>"; }).join("") + "</ul>";
      html += '<h3 class="sq-h3">Why this one, for you</h3><ol class="sq-reasons">' + reasons.map(function (r, i) { return "<li><i>" + (i + 1) + "</i><p>" + esc(r) + "</p></li>"; }).join("") + "</ol>";
      html += '<h3 class="sq-h3">What’s in the box</h3><ul class="sq-box">' + kit.contents.map(function (c) { return '<li><span class="sq-trust__ic">' + ICONS.check + "</span>" + esc(c) + "</li>"; }).join("") + "</ul>";
      html += '<div class="sq-trustcard">' + trustList(trust, true) + '<p class="sq-fine">' + esc(trust.madeSafe) + " · " + esc(trust.sharkTank) + " · Featured in " + esc(trust.press.join(", ")) + "</p></div>";
      html += '<div class="sq-links"><a href="' + esc(data.collectionUrl) + '">See all 7 kits in the ₹899 collection</a><button type="button" data-sq="restart">Retake the quiz</button></div>';
      html += '<div class="sq-sticky"><div class="sq-sticky__in"><div class="sq-sticky__t"><b>' + esc(kit.title) + "</b><span><b>" + inr(kit.price) + "</b> <s>" + inr(kit.mrp) + "</s></span></div>";
      html += '<a class="sq-btn" href="' + esc(buy) + '" data-sq="buy" data-variant="' + esc(kit.variantId) + '">Add my kit · ' + inr(kit.price) + " " + ICONS.arrow + "</a></div></div></section>";
      root.innerHTML = html;
    }

    function scrollTop() {
      var sc = opts.scrollEl || window;
      if (sc === window) window.scrollTo({ top: Math.max(0, root.getBoundingClientRect().top + window.pageYOffset - 16) });
      else sc.scrollTop = 0;
    }

    root.addEventListener("click", function (e) {
      var el = e.target.closest("[data-sq]");
      if (!el) return;
      var act = el.getAttribute("data-sq");
      if (act === "opt") {
        var q = QUESTIONS[state.step];
        state.answers[q.id] = el.getAttribute("data-id");
        renderQuiz();
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (state.step + 1 < QUESTIONS.length) { state.step++; renderQuiz(); }
          else { state.stage = "matching"; renderMatching(); }
          scrollTop();
        }, 260);
      } else if (act === "browse") {
        // Let the link navigate, but record the skip first so the order knows.
        e.preventDefault();
        var to = el.getAttribute("href");
        var go = function () { window.location.href = to; };
        var t = setTimeout(go, 700);
        stampPath("collection").then(function () { clearTimeout(t); go(); });
      } else if (act === "start") {
        stampPath("quiz");
        state.stage = "quiz"; renderQuiz(); scrollTop();
      } else if (act === "back") {
        if (state.step === 0) {
          if (opts.onClose) opts.onClose();
          else if (opts.intro) { state.stage = "intro"; renderIntro(); }
          return;
        }
        state.step--; renderQuiz();
      } else if (act === "buy") {
        // Add in place and open the KwikCart drawer; fall back to the permalink.
        if (typeof window.openGokwikSideCart !== "function" || !window.fetch) return;
        e.preventDefault();
        var btn = el, href = el.getAttribute("href"), variantId = el.getAttribute("data-variant");
        var attrs = { quiz: "oral-care-quiz" };
        Object.keys(state.answers).forEach(function (k) { attrs["quiz_" + k] = state.answers[k]; });
        btn.classList.add("is-busy"); btn.setAttribute("aria-busy", "true");
        var label = btn.innerHTML; btn.innerHTML = "Adding…";
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw new Error("add failed"); return stampPath("buy", attrs); })
          .then(function () {
            if (typeof window.refreshSideCart === "function") { try { window.refreshSideCart(); } catch (err) {} }
            window.openGokwikSideCart();
            btn.innerHTML = label; btn.classList.remove("is-busy"); btn.removeAttribute("aria-busy");
          })
          .catch(function () { window.location.href = href; });
      } else if (act === "restart") {
        state = { stage: "quiz", step: 0, answers: {} }; renderQuiz(); scrollTop();
      }
    });

    render();
    return { reset: function () { state = { stage: "quiz", step: 0, answers: {} }; render(); } };
  }

  function readData(el) {
    var s = el.querySelector("script[data-sq-data]");
    return s ? JSON.parse(s.textContent) : null;
  }

  function boot() {
    document.querySelectorAll("[data-sq-inline]").forEach(function (wrap) {
      if (wrap.dataset.sqMounted) return;
      wrap.dataset.sqMounted = "1";
      var data = readData(wrap), root = wrap.querySelector(".sq-root");
      if (data && root) mount(root, data, { intro: true });
    });
    document.querySelectorAll("[data-sq-popup]").forEach(function (wrap) {
      if (wrap.dataset.sqMounted) return;
      wrap.dataset.sqMounted = "1";
      var data = readData(wrap), card = wrap.querySelector(".sq-pop"), sheet = wrap.querySelector(".sq-sheet"), root = sheet.querySelector(".sq-root");
      var delay = parseInt(wrap.dataset.sqDelay || "1200", 10), quiz = null;
      var key = "perfora-sq-dismissed";
      try { if (sessionStorage.getItem(key)) { card.remove(); card = null; } } catch (e) {}
      if (card) setTimeout(function () { card.classList.remove("is-hidden"); }, delay);
      function open() {
        if (card) card.classList.add("is-hidden");
        sheet.hidden = false; document.body.classList.add("sq-lock");
        if (!quiz) quiz = mount(root, data, { onClose: close, scrollEl: sheet }); else quiz.reset();
      }
      function close() {
        sheet.hidden = true; document.body.classList.remove("sq-lock");
        if (card) card.classList.remove("is-hidden");
      }
      wrap.addEventListener("click", function (e) {
        if (e.target.closest("[data-sq-open]")) open();
        else if (e.target.closest("[data-sq-dismiss]")) {
          try { sessionStorage.setItem(key, "1"); } catch (err) {}
          if (card) { card.classList.add("is-hidden"); }
        }
      });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !sheet.hidden) close(); });
    });
  }

  window.SmileQuiz = { mount: mount, boot: boot };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
